import { ContentContainer, Spinner, Text } from '@ahc-digital/component-library';
import { Field, Text as JSSText } from '@sitecore-jss/sitecore-jss-nextjs';
import Script from 'next/script';
import { useState } from 'react';
import { PromptForErrorMessage } from 'src/shared/PromptForErrorMessage';
import { RenderingProps } from 'src/shared/shared.types';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';

export const Default = (props: RenderingProps<{ UUID: Field<string> }>): JSX.Element => {
  const { fields } = props;
  const [isError, setIsError] = useState(false);
  const context = useCustomSitecoreContext();
  const isEditing = context?.pageEditing ?? false;
  const [isJQueryLoading, setIsJQueryLoading] = useState(true);
  const [isSparkleLoading, setIsSparkleLoading] = useState(true);
  const sparkleApiBaseUrl = context?.sparkleApiBaseUrl?.value;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!sparkleApiBaseUrl) {
    return (
      <PromptForErrorMessage
        componentName="E02 - Event Search"
        message="Sparkle API base URL not found."
      />
    );
  }

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <ContentContainer
          spacing="40-24"
          supportCopyAlignment="left"
          supportCopy={
            <>
              <h4>Configuration Details:</h4>
              <p>
                <b>Sparkle API base URL:</b> {sparkleApiBaseUrl} <br />
              </p>
            </>
          }
        >
          <Text tag="p" fontStyle="smParagraphBold">
            UUID:
          </Text>
          <br />
          <JSSText field={fields?.UUID} />
        </ContentContainer>
      </SwitchToPreviewMessage>
    );
  }

  const uuid = fields?.UUID?.value;

  if (!uuid) {
    return <></>;
  }

  return (
    <>
      <Script
        src="https://code.jquery.com/jquery-3.7.1.min.js"
        integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo="
        crossOrigin="anonymous"
        onError={() => {
          setIsError(true);
        }}
        onReady={() => {
          setIsJQueryLoading(false);
        }}
      />
      <div id="sparkle-event-search-container" data-component={marketingRenderingName}>
        {(isSparkleLoading || isJQueryLoading) && !isError && (
          <ContentContainer spacing="40-24">
            <Spinner />
          </ContentContainer>
        )}

        {isError && (
          <ContentContainer
            headline="Something went wrong"
            headlineTag="h3"
            spacing="40-24"
            supportCopy={<p>There was an error search results. Please try again later.</p>}
          />
        )}
      </div>
      {!isJQueryLoading && !isError && (
        <Script
          src={`${sparkleApiBaseUrl}/assets/embed/event_search.js`}
          onError={() => {
            setIsError(true);
          }}
          onReady={() => {
            if (isError) return;
            new Sparkle.Embed.EventSearch('sparkle-event-search-container', {
              uuid,
            })
              .then(() => {
                setIsSparkleLoading(false);
              })
              .catch(() => {
                setIsSparkleLoading(false);
                setIsError(true);
              });
          }}
        />
      )}
    </>
  );
};
